import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { apiResponse } from "../../../../utils/apiResponse";
import { apiCall } from "../../../../utils/axiosService";
import { Button, Form, Table } from "react-bootstrap";
import { commonService } from "../../../../utils/commonService";
import Loader from "../../../Loader/Loader";
import { compName, month } from "../../../../utils/constant";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import moment from "moment";
import { API_URL } from "../../../../utils/apiRoutes";
import { Line } from "react-chartjs-2";
import {
    Chart,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    PointElement,
    LineElement,
    Filler,
} from "chart.js";
import WidgetDetailModal from "../../WidgetDetailModal";
import AddWidgetModal from "../../AddWidgetModal";
import SixtyDayChild from "../RevPak/SixtyDayChild";
import downArrow from "../../../../Assets/Images/Header/downArrow.svg";
import DoughnutChart from "../../../CommonComponent/DoughnutChart ";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import EventStretegy from "../Event/EventStretegy";

const MonthlyData = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const [stlyToggle, setStylToggle] = useState(false);
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );
    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );
    const { snapshottitle, propertyCode, snapshotId } = useParams();
    let datesArray = commonService.getAllDatesInMonth(
        new Date(para?.asOfDate).getFullYear(),
        new Date(para?.asOfDate).getMonth()
    );
    const monthDataArrRef = useRef([]);
    const [monthData, setMonthData] = useState(null);
    const [monthDataLoading, setMonthDataLoading] = useState(false);
    const [showNoteSidebar, setShowNoteSidebar] = useState(false);
    const [widgetModal, setWidgetModal] = useState(false);
    const [chartData, setChartData] = useState(null);
    const widgetDetailRef = useRef();
    const clickedDateForNote = useRef();
    const callApi = useRef(false);
    const isFilterApiCalled = useRef(false);
    const [segmentDrilldownData, setSegmentDrilldownData] = useState(null);
    const [loading, setLoading] = useState(false);
    const rateCodeDataRef = useRef(false);
    const companyDataRef = useRef(false);
    const guestDataRef = useRef(false);
    const totalRef = useRef();
    const clickedTrRef = useRef();
    const selectedMarketSegmentRef = useRef();
    const selectedRateCodeRef = useRef();
    const selectedCompanyRef = useRef();
    const calledMarketSegmentRef = useRef([]);
    const [msLoading, setMsLoading] = useState(false);
    const calledRateCodeRef = useRef([]);
    const [rateCodeLoading, setRateCodeLoading] = useState(false);
    const calledCompanyRef = useRef([]);
    const [companyLoading, setCompanyLoading] = useState(false);
    const [msChartData, setMsChartData] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState("");
    const monthStartDateRef = useRef();
    const monthEndDateRef = useRef();
    const bookingPaceChartDateRef = useRef();
    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const closeNoteSideBar = () => {
        setShowNoteSidebar(false);
    };

    var curr = new Date(para?.asOfDate);
    var first = curr.getDate() - curr.getDay();
    var last = first + 6;

    var firstday = new Date(curr.setDate(first));
    var lastday = new Date(curr.setDate(last));

    const getDataForMonth = async () => {
        let date = moment(para?.asOfDate);
        setMonthDataLoading(true);
        let dataForMonthResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.EMAIL_WIDGET.DAILY_DATA_WIDGET_TWO,
                body: {
                    propertyCode: para?.propertyCode,
                    AsOfDate: para?.asOfDate,
                    year: new Date(para?.asOfDate).getFullYear(),
                    startDate: monthStartDateRef.current
                        ? monthStartDateRef.current
                        : date.startOf("month").format("YYYY-MM-DD"),
                    ForcastType: propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term ? propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term.toLowerCase() : "ema"
                },
            },
            false
        );

        let response = apiResponse(false, dataForMonthResponse);

        if (response?.isValidate) {
            let asDate1 = new Date(
                monthStartDateRef.current ? monthStartDateRef.current : para?.asOfDate
            );
            let asDate2 = new Date(
                monthStartDateRef.current ? monthStartDateRef.current : para?.asOfDate
            );
            let prevAsDate = new Date(asDate1.setMonth(asDate1.getMonth() - 1));
            let nextAsDate = new Date(asDate2.setMonth(asDate2.getMonth() + 1));
            monthDataArrRef.current = [
                moment(prevAsDate).format("MMMM"),
                moment(
                    monthStartDateRef.current ? monthStartDateRef.current : para?.asOfDate
                ).format("MMMM"),
                moment(nextAsDate).format("MMMM"),
            ];
            setMonthData(response?.data?.data);
            setMonthDataLoading(false);
        }

        if (!response?.isValidate) {
            let asDate1 = new Date(
                monthStartDateRef.current ? monthStartDateRef.current : para?.asOfDate
            );
            let asDate2 = new Date(
                monthStartDateRef.current ? monthStartDateRef.current : para?.asOfDate
            );
            let prevAsDate = new Date(asDate1.setMonth(asDate1.getMonth() - 1));
            let nextAsDate = new Date(asDate2.setMonth(asDate2.getMonth() + 1));
            monthDataArrRef.current = [
                moment(prevAsDate).format("MMMM"),
                moment(
                    monthStartDateRef.current ? monthStartDateRef.current : para?.asOfDate
                ).format("MMMM"),
                moment(nextAsDate).format("MMMM"),
            ];
            setMonthData(null);
            setMonthDataLoading(false);
        }
    };

    let prevYear = {
        label: "Prev Year",
        backgroundColor: "#97C2E0",
        data: [],
        stack: "stack1",
    };

    let currentYear = {
        label: "Current Year",
        backgroundColor: "#7ACFA2",
        data: [],
        stack: "stack2",
    };

    const getBookingPaceDetail = async () => {
        let bookingPaceResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.BOOKING_PACE.CHART,
                body: {
                    AsOfDate: bookingPaceChartDateRef.current
                        ? bookingPaceChartDateRef.current
                        : para?.asOfDate,
                    propertyCode: para?.propertyCode,
                },
            },
            false
        );

        let response = apiResponse(false, bookingPaceResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;

            datesArray?.map((item) => {
                let findData = dataFromApi?.filter(
                    (x) => {
                        if (
                            commonService.convertDateInTimezone(x?.Dates).getDate() === item
                        ) {
                            return x;
                        }
                    }
                    // new Date(x?.Dates).getDate() === item
                );
                prevYear.data = [
                    ...prevYear.data,
                    findData?.[0]?.TotalRevenuePreviousYear
                        ? parseInt(findData?.[0]?.TotalRevenuePreviousYear)
                        : 0,
                ];
                currentYear.data = [
                    ...currentYear.data,
                    findData?.[0]?.TotalRevenueCurrentYear
                        ? parseInt(findData?.[0]?.TotalRevenueCurrentYear)
                        : 0,
                ];
            });

            setChartData([prevYear, currentYear]);
        }

        if (!response?.isValidate) {
            prevYear.data = [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0,
            ];
            currentYear.data = [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0,
            ];
            setChartData([prevYear, currentYear]);
        }
    };
    let chartDetail = {};

    if (chartData) {
        chartDetail = {
            labels: datesArray,
            datasets: [
                {
                    type: "line",
                    label: `${new Date().getFullYear() - 1}`,
                    backgroundColor: chartData?.[0]?.backgroundColor,
                    data: chartData?.[0]?.data,
                    stack: chartData?.[0]?.stack || "default",
                    fill: {
                        target: "origin",
                        above: "rgba(151, 194, 224, 0.4)",
                    },
                },
                {
                    type: "line",
                    label: `${new Date().getFullYear()}`,
                    backgroundColor: chartData?.[1]?.backgroundColor,
                    data: chartData?.[1]?.data,
                    // fill: true,
                    fill: {
                        target: "origin",
                        above: "rgba(122, 207, 162, 0.4)",
                    },
                    stack: chartData?.[1]?.stack || "default",
                },
            ],
        };
    }

    let chartOptions = {
        indexAxis: "x",
        scales: {
            x: {
                stacked: true,
                title: {
                    display: true,
                    text: "",
                },
                ticks: {
                    align: "start",
                    autoSkip: false,
                },
            },
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: "",
                },
                grid: {
                    display: true,
                },
                offset: true,
                ticks: {
                    callback: function (value) {
                        return `${propertyDetailFromRTK?.currency_term
                                ? propertyDetailFromRTK?.currency_term
                                : "$"
                            }${value}`;
                    },
                },
            },
        },

        plugins: {
            legend: {
                display: true,
                align: "end",
                position: "top",
                maxWidth: 20,
                maxHeight: 100,
                labels: {
                    boxWidth: 10,
                    boxHeight: 10,
                },
            },
            tooltip: {
                enabled: true,
                mode: "index",
                callbacks: {
                    title: function (context) {
                        return context[0].label;
                    },
                    label: function (context) {
                        let label = context.dataset.label;
                        let value = context.formattedValue;
                        return `${label}: ${value}`;
                    },
                },
            },
        },
        responsive: true,
        barThickness: 12,
        categorySpacing: 0.3,
        barPercentage: 0.8,
        categoryPercentage: 0.9,
    };

    Chart.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Tooltip,
        Legend,
        PointElement,
        LineElement,
        Filler
    );

    const showOnApiCall = (idArray) => {
        for (let i = 0; i < idArray?.length; i++) {
            const classList = document.getElementsByClassName(idArray[i]);
            for (let i = 0; i < classList?.length; i++) {
                if (classList[i].classList.contains("nestedTableRowNone")) {
                    classList[i].classList.remove("nestedTableRowNone");
                    classList[i].classList.add("singleDateSummmaryTr");
                }
            }
        }
    };

    const handleShowHideRow = (className, itemDetail) => {
        if (document.getElementById(className) !== null) {
            if (document.getElementById(className).classList.contains("active")) {
                document.getElementById(className).classList.remove("active");
            } else {
                document.getElementById(className).classList.add("active");
            }
        }

        const removeClass = (classNameDetail) => {
            const classList = document.getElementsByClassName(classNameDetail);
            for (let i = 0; i < classList?.length; i++) {
                if (classList[i].classList.contains("nestedTableRowNone")) {
                    classList[i].classList.remove("nestedTableRowNone");
                    classList[i].classList.add("singleDateSummmaryTr");
                } else {
                    classList[i].classList.add("nestedTableRowNone");
                    classList[i].classList.remove("singleDateSummmaryTr");
                }
            }
        };

        removeClass(className);

        const addChildClass = (childClassName) => {
            const classList = document.getElementsByClassName(childClassName);
            for (let i = 0; i < classList?.length; i++) {
                if (!classList[i].classList.contains("nestedTableRowNone")) {
                    classList[i].classList.add("nestedTableRowNone");
                    classList[i].classList.remove("singleDateSummmaryTr");
                }
            }
        };

        const removeAllClass = (childItems) => {
            for (let i = 0; i < childItems?.length; i++) {
                addChildClass(childItems[i]?.guid);

                if (
                    Array.isArray(childItems[i]?.items) &&
                    childItems[i]?.items?.length > 0
                ) {
                    removeAllClass(childItems[i]?.items);
                }
            }
        };

        if (Array.isArray(itemDetail?.items) && itemDetail?.items?.length > 0) {
            removeAllClass(itemDetail?.items);
        }
    };

    const checkActiveRow = (e, guid, itemDetail) => {
        if (e.currentTarget.classList.contains("active")) {
            e.currentTarget.classList.remove("active");
            e.currentTarget.classList.remove("singleDateSummmaryTr");
        } else {
            e.currentTarget.classList.add("active");
            e.currentTarget.classList.add("singleDateSummmaryTr");
        }
    };

    const getMarketSegmentData = async () => {
        setLoading(true);

        let marketSegmentResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.EMAIL_WIDGET.MONTHLY_MS,
                body: {
                    propertyCode: para?.propertyCode,
                    AsOfDate: para?.asOfDate,
                },
            },
            false
        );

        let response = apiResponse(false, marketSegmentResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;
            let total = {
                leftRoom: 0,
                leftAdr: 0,
                leftRev: 0,
                leftRevContri: 100,
                rightRoom: 0,
                rightAdr: 0,
                rightRev: 0,
                rightRevContri: 100,

                stly_rightRoom: 0,
                stly_rightAdr: 0,
                stly_rightRev: 0,
                stly_rightRevContri: 100,
            };
            let doughnutData = {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [],
                        hoverBackgroundColor: [],
                    },
                ],
            };

            let groupingData = dataFromApi?.map((item) => {
                // let color = Math.floor(Math.random() * 16777215).toString(16);
                let color = commonService.CreateColor(`${item.marketsegment}`).BGColor;
                let marketSegmentName = item.marketsegment;
                let marketSegmentPr = item?.left_RMS ? item?.left_RMS : 0;
                doughnutData.labels.push(marketSegmentName);
                doughnutData.datasets[0].data.push(marketSegmentPr);
                doughnutData.datasets[0].backgroundColor.push(`${color}`);
                doughnutData.datasets[0].hoverBackgroundColor.push(`${color}`);

                item.items = [];
                item.guid = commonService.GenerateGUID();
                item.name = item?.marketsegment;
                item.varientRms =
                    (item?.left_RMS ? parseInt(item?.left_RMS) : 0) -
                    (item?.right_RMS ? parseInt(item?.right_RMS) : 0);
                item.varientAdr =
                    (item?.left_ADR ? parseInt(item?.left_ADR) : 0) -
                    (item?.right_ADR ? parseInt(item?.right_ADR) : 0);
                item.varientRev =
                    (item?.left_REV ? parseInt(item?.left_REV) : 0) -
                    (item?.right_REV ? parseInt(item?.right_REV) : 0);

                if (item?.left_RMS) {
                    total.leftRoom = total.leftRoom + parseInt(item?.left_RMS);
                }
                if (item?.left_ADR) {
                    total.leftAdr = total.leftAdr + parseInt(item?.left_ADR);
                }
                if (item?.left_REV) {
                    total.leftRev = total.leftRev + parseInt(item?.left_REV);
                }

                if (item?.right_RMS) {
                    total.rightRoom = total.rightRoom + parseInt(item?.right_RMS);
                }
                if (item?.right_ADR) {
                    total.rightAdr = total.rightAdr + parseInt(item?.right_ADR);
                }
                if (item?.right_REV) {
                    total.rightRev = total.rightRev + parseInt(item?.right_REV);
                }


                if (item?.stly_RMS) {
                    total.stly_rightRoom = total.stly_rightRoom + parseInt(item?.stly_RMS);
                }
                if (item?.stly_ADR) {
                    total.stly_rightAdr = total.stly_rightAdr + parseInt(item?.stly_ADR);
                }
                if (item?.stly_REV) {
                    total.stly_rightRev = total.stly_rightRev + parseInt(item?.stly_REV);
                }




                item.stlyRms =
                    (item?.left_RMS ? parseInt(item?.left_RMS) : 0) -
                    (item?.right_RMS ? parseInt(item?.stly_RMS) : 0);
                item.stlyAdr =
                    (item?.left_ADR ? parseInt(item?.left_ADR) : 0) -
                    (item?.right_ADR ? parseInt(item?.stly_ADR) : 0);
                item.stlyRev =
                    (item?.left_REV ? parseInt(item?.left_REV) : 0) -
                    (item?.right_REV ? parseInt(item?.stly_REV) : 0);




                return item;
            });

            setMsChartData(doughnutData);
            setSegmentDrilldownData(groupingData);
            totalRef.current = total;
            setLoading(false);
        }

        if (!response?.isValidate) {
            setSegmentDrilldownData([]);
            setLoading(false);
        }
    };

    const getRateCodeData = async () => {
        setMsLoading(true);
        let rateCodeResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.EMAIL_WIDGET.MONTHLY_RATECODE,
                body: {
                    propertyCode: para?.propertyCode,
                    AsOfDate: para?.asOfDate,
                    selectedMarketSegment: selectedMarketSegmentRef.current,
                },
            },
            false
        );

        let response = apiResponse(false, rateCodeResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;

            let groupingJson = [...segmentDrilldownData];

            dataFromApi?.forEach((item) => {
                let findMarketsegment = groupingJson?.findIndex(
                    (x) => x?.name === item?.MarketSegment
                );

                if (findMarketsegment >= 0) {
                    item.name = item?.RateCode;
                    item.items = [];
                    item.varientRms =
                        (item?.left_RMS ? parseInt(item?.left_RMS) : 0) -
                        (item?.right_RMS ? parseInt(item?.right_RMS) : 0);
                    item.varientAdr =
                        (item?.left_ADR ? parseInt(item?.left_ADR) : 0) -
                        (item?.right_ADR ? parseInt(item?.right_ADR) : 0);
                    item.varientRev =
                        (item?.left_REV ? parseInt(item?.left_REV) : 0) -
                        (item?.right_REV ? parseInt(item?.right_REV) : 0);
                    item.guid = commonService.GenerateGUID();

                    item.stlyRms =
                        (item?.left_RMS ? parseInt(item?.left_RMS) : 0) -
                        (item?.right_RMS ? parseInt(item?.stly_RMS) : 0);
                    item.stlyAdr =
                        (item?.left_ADR ? parseInt(item?.left_ADR) : 0) -
                        (item?.right_ADR ? parseInt(item?.stly_ADR) : 0);
                    item.stlyRev =
                        (item?.left_REV ? parseInt(item?.left_REV) : 0) -
                        (item?.right_REV ? parseInt(item?.stly_REV) : 0);


                    groupingJson[findMarketsegment].items = [
                        ...groupingJson?.[findMarketsegment]?.items,
                        item,
                    ];
                }
            });
            calledMarketSegmentRef.current = [
                ...calledMarketSegmentRef.current,
                selectedMarketSegmentRef.current,
            ];
            setSegmentDrilldownData(groupingJson);
            setMsLoading(false);
        }

        if (!response?.isValidate) {
            setMsLoading(false);
        }
    };

    const getCompanyData = async () => {
        setRateCodeLoading(true);
        let companyDataResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.EMAIL_WIDGET.MONTHLY_COMPANY,
                body: {
                    propertyCode: para?.propertyCode,
                    AsOfDate: para?.asOfDate,
                    selectedMarketSegment: selectedMarketSegmentRef.current,
                    selectedRateCode: selectedRateCodeRef.current,
                },
            },
            false
        );

        let response = apiResponse(false, companyDataResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;

            let groupingJson = [...segmentDrilldownData];

            dataFromApi?.forEach((item) => {
                let findMarketsegment = groupingJson?.findIndex(
                    (x) => x?.name === item?.MarketSegment
                );
                let findRatecode = groupingJson[findMarketsegment].items?.findIndex(
                    (x) => x?.name === item?.RateCode
                );

                if (findRatecode >= 0) {
                    item.name = item?.Company;
                    item.items = [];
                    item.varientRms =
                        (item?.left_RMS ? parseInt(item?.left_RMS) : 0) -
                        (item?.right_RMS ? parseInt(item?.right_RMS) : 0);
                    item.varientAdr =
                        (item?.left_ADR ? parseInt(item?.left_ADR) : 0) -
                        (item?.right_ADR ? parseInt(item?.right_ADR) : 0);
                    item.varientRev =
                        (item?.left_REV ? parseInt(item?.left_REV) : 0) -
                        (item?.right_REV ? parseInt(item?.right_REV) : 0);
                    item.stlyRms =
                        (item?.left_RMS ? parseInt(item?.left_RMS) : 0) -
                        (item?.right_RMS ? parseInt(item?.stly_RMS) : 0);
                    item.stlyAdr =
                        (item?.left_ADR ? parseInt(item?.left_ADR) : 0) -
                        (item?.right_ADR ? parseInt(item?.stly_ADR) : 0);
                    item.stlyRev =
                        (item?.left_REV ? parseInt(item?.left_REV) : 0) -
                        (item?.right_REV ? parseInt(item?.stly_REV) : 0);

                    item.guid = commonService.GenerateGUID();
                    groupingJson[findMarketsegment].items[findRatecode].items = [
                        ...groupingJson[findMarketsegment].items[findRatecode].items,
                        item,
                    ];
                }
            });
            calledRateCodeRef.current = [
                ...calledRateCodeRef.current,
                {
                    ms: selectedMarketSegmentRef.current,
                    rc: selectedRateCodeRef.current,
                },
            ];
            setSegmentDrilldownData(groupingJson);
            setRateCodeLoading(false);
        }

        if (!response?.isValidate) {
            setRateCodeLoading(false);
        }
    };

    const getGuestData = async () => {
        setCompanyLoading(true);
        let guestDataResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.EMAIL_WIDGET.MONTHLY_GUESTNAME,
                body: {
                    propertyCode: para?.propertyCode,
                    AsOfDate: para?.asOfDate,
                    selectedMarketSegment: selectedMarketSegmentRef.current,
                    selectedRateCode: selectedRateCodeRef.current,
                    selectedCompany: selectedCompanyRef.current,
                },
            },
            false
        );

        let response = apiResponse(false, guestDataResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;

            let groupingJson = [...segmentDrilldownData];

            dataFromApi?.forEach((item) => {
                let findMarketsegment = groupingJson?.findIndex(
                    (x) => x?.name === item?.MarketSegment
                );
                let findRatecode = groupingJson[findMarketsegment].items?.findIndex(
                    (x) => x?.name === item?.RateCode
                );

                let findCompany = groupingJson[findMarketsegment].items[
                    findRatecode
                ].items?.findIndex((x) => x?.name === item?.Company);

                if (findCompany >= 0) {
                    item.name = item?.GuestName;
                    item.items = [];
                    item.varientRms =
                        (item?.left_RMS ? parseInt(item?.left_RMS) : 0) -
                        (item?.right_RMS ? parseInt(item?.right_RMS) : 0);
                    item.varientAdr =
                        (item?.left_ADR ? parseInt(item?.left_ADR) : 0) -
                        (item?.right_ADR ? parseInt(item?.right_ADR) : 0);
                    item.varientRev =
                        (item?.left_REV ? parseInt(item?.left_REV) : 0) -
                        (item?.right_REV ? parseInt(item?.right_REV) : 0);
                    item.stlyRms =
                        (item?.left_RMS ? parseInt(item?.left_RMS) : 0) -
                        (item?.right_RMS ? parseInt(item?.stly_RMS) : 0);
                    item.stlyAdr =
                        (item?.left_ADR ? parseInt(item?.left_ADR) : 0) -
                        (item?.right_ADR ? parseInt(item?.stly_ADR) : 0);
                    item.stlyRev =
                        (item?.left_REV ? parseInt(item?.left_REV) : 0) -
                        (item?.right_REV ? parseInt(item?.stly_REV) : 0);

                    item.guid = commonService.GenerateGUID();
                    groupingJson[findMarketsegment].items[findRatecode].items[
                        findCompany
                    ].items = [
                            ...groupingJson[findMarketsegment].items[findRatecode].items[
                                findCompany
                            ].items,
                            item,
                        ];
                }
            });
            calledCompanyRef.current = [
                ...calledCompanyRef.current,
                {
                    ms: selectedMarketSegmentRef.current,
                    rc: selectedRateCodeRef.current,
                    company: selectedCompanyRef.current,
                },
            ];
            setSegmentDrilldownData(groupingJson);
            setCompanyLoading(false);
        }

        if (!response?.isValidate) {
            setCompanyLoading(false);
        }
    };


    useEffect(() => {
        if (api === 0) {
            let asDate11 = new Date(para?.asOfDate);
            let asDate22 = new Date(para?.asOfDate);
            let prevAsDate = new Date(asDate11.setMonth(asDate11.getMonth() - 1));
            let nextAsDate = new Date(asDate22.setMonth(asDate22.getMonth() + 1));
            monthDataArrRef.current = [
                moment(prevAsDate).format("MMMM"),
                moment(para?.asOfDate).format("MMMM"),
                moment(nextAsDate).format("MMMM"),
            ];
        } else {
            if (para?.asOfDate) {
                getDataForMonth();
                getBookingPaceDetail();
            }
        }
    }, [para?.asOfDate, selectedMonth]);

    useEffect(() => {
        if (api === 0) {
        } else {
            if (para?.asOfDate) {
                getMarketSegmentData();
            }
        }
    }, [para?.asOfDate, callApi.current, selectedMonth]);

    useLayoutEffect(() => {
        if (clickedTrRef.current) {
            showOnApiCall(clickedTrRef.current);
        }
    }, [
        rateCodeDataRef.current,
        companyDataRef.current,
        guestDataRef.current,
        segmentDrilldownData,
    ]);

    const chartDoughnutOptions = {
        plugins: {
            legend: {
                display: false,
            },
        },
        elements: {
            arc: {
                borderWidth: 0,
                spacing: 0,
            },
        },
        legend: {
            display: true,
            position: "right",
        },
    };

    const [tblids, settblids] = useState({
        annualSummaryMonthly: commonService.GenerateGUID(),
        eMonthlyData: commonService.GenerateGUID(),
        eReservationData: commonService.GenerateGUID(),
        drilldown: commonService.GenerateGUID(),
    });
    return (
        <div>
            <Form.Select id={commonService.generateGlobalClickTrackerID("MonthlyData", "form-select-onchange", propertyCode)}
                className="width150 mb-2"
                value={selectedMonth}
                onChange={(e) => {
                    if (e?.target?.value) {
                        let date = moment(
                            `${e.target.value} ${new Date().getFullYear()}`,
                            "MMMM YYYY"
                        );
                        let startDate = date.format("YYYY-MM-DD");
                        let lastDate = date.endOf("month").format("YYYY-MM-DD");
                        bookingPaceChartDateRef.current = lastDate;
                        if (moment(defaultAsOfDateFromRTK).isSameOrBefore(lastDate)) {
                            bookingPaceChartDateRef.current = defaultAsOfDateFromRTK;
                        }
                        monthStartDateRef.current = startDate;
                        monthEndDateRef.current = lastDate;
                    } else {
                        monthStartDateRef.current = "";
                        monthEndDateRef.current = "";
                        bookingPaceChartDateRef.current = "";
                    }
                    setSelectedMonth(e.target.value);
                }}
            >
                <option value="">Select Month</option>
                {month?.map((item, index) => (
                    <option key={item} value={item}>
                        {item}
                    </option>
                ))}
            </Form.Select>
            {/* ANNUAL SUMMARY DATA */}
            <div className="eMonthlyData-widget-container">
                <p>{`Annual Summary`}</p>
                {api !== 0 && (
                    <div className="gap-1 eMonthlyData-widget-container-menu">
                        {/* <Button
              className="heading-menu-btns"
              type="button"
              onClick={() => {
                clickedDateForNote.current = "";
                setShowNoteSidebar(true);
              }}
            >
              <img src={NoteIcon} alt="note" />
            </Button> */}
                        <Button
                            className="heading-menu-btns"
                            type="button"
                            title="Send Mail"
                        >
                            <img id={commonService.generateGlobalClickTrackerID("MonthlyData", "emailicon", propertyCode)}
                                src={emailIcon}
                                alt="emailIcon"
                                onClick={() => {
                                    commonService.fnSendWidgetMail(
                                        tblids.annualSummaryMonthly,
                                        "Email Monthly Data",
                                        snapshotId,
                                        defaultAsOfDateFromRTK,
                                        "",
                                        para?.widgetId
                                    );
                                }}
                            />
                        </Button>
                        <Button className="heading-menu-btns" type="button">
                            <img id={commonService.generateGlobalClickTrackerID("MonthlyData", "info", propertyCode)}
                                src={infoIcon}
                                alt="info"
                                onClick={() => {
                                    widgetDetailRef.current = {
                                        widgetdetails: "",
                                        usernote: "",
                                        compName: compName?.monthlyDataForEmail,
                                        widgetId: para?.widgetId,
                                    };
                                    setWidgetModal(true);
                                }}
                            />
                        </Button>
                        <Button className="heading-menu-btns" type="button">
                            <img id={commonService.generateGlobalClickTrackerID("MonthlyData", "download", propertyCode)}
                                src={downloadIcon}
                                alt="download"
                                import={tblids.annualSummaryMonthly}
                                onClick={() =>
                                    commonService.fnExportInCSV(
                                        tblids.annualSummaryMonthly,
                                        // "Email Monthly Data"
                                        `${para?.propertyCode}-Email Monthly Data-${moment(
                                            new Date()
                                        ).format("MMDDYYYY")}`
                                    )
                                }
                            />
                        </Button>
                    </div>
                )}
                <div className="ViewPropertySetupTable">
                    <div className="stripped__table">
                        <Table id={tblids.annualSummaryMonthly} responsive>
                            <thead>
                                <tr>
                                    <th className="border_right"></th>
                                    <th colSpan={4} className="text-center border_right">
                                        On The Book
                                    </th>
                                    <th colSpan={4} className="text-center border_right">
                                        Net Stly
                                    </th>
                                    <th colSpan={4} className="text-center border_right">
                                        Total Ly
                                    </th>
                                    <th colSpan={4} className="text-center border_right">
                                        Budget
                                    </th>
                                    <th colSpan={4} className="text-center">
                                        Forecast
                                    </th>
                                </tr>
                                <tr>
                                    <th className="border_right"></th>
                                    <th className="text-center">OCC</th>
                                    <th className="text-center">RMS</th>
                                    <th className="text-end">ADR</th>
                                    <th className="border_right text-end">REV</th>
                                    <th className="text-center">OCC</th>
                                    <th className="text-center">RMS</th>
                                    <th className="text-end">ADR</th>
                                    <th className="border_right text-end">REV</th>
                                    <th className="text-center">OCC</th>
                                    <th className="text-center">RMS</th>
                                    <th className="text-end">ADR</th>
                                    <th className="border_right text-end">REV</th>
                                    <th className="text-center">OCC</th>
                                    <th className="text-center">RMS</th>
                                    <th className="text-end">ADR</th>
                                    <th className="border_right text-end">REV</th>
                                    <th className="text-center">OCC</th>
                                    <th className="text-center">RMS</th>
                                    <th className="text-end">ADR</th>
                                    <th className="text-end">REV</th>
                                </tr>
                            </thead>
                            <tbody>
                                {monthDataLoading ? (
                                    <tr style={{ height: "80px", position: "relative" }}>
                                        <Loader />
                                    </tr>
                                ) : (
                                    monthDataArrRef.current?.map((item, index) => {
                                        let singleData = monthData?.filter(
                                            (x) => item === x?.Month?.trim()
                                        );

                                        return (
                                            <tr key={item} className="shadowOnHover">
                                                {/* <td className="border_right">{`${item} ${moment(
                          para?.asOfDate
                        ).format("YYYY")}`}</td> */}
                                                <td className="border_right">{`${item} ${singleData?.[0]?.Year}`}</td>
                                                <td className="text-center">
                                                    {singleData?.[0]?.OCC ? singleData?.[0]?.OCC : 0}%
                                                </td>
                                                <td className="text-center">
                                                    {singleData?.[0]?.RMS
                                                        ? commonService.formateRoom(singleData?.[0]?.RMS)
                                                        : 0}
                                                </td>
                                                <td className="text-end">
                                                    {singleData?.[0]?.ADR
                                                        ? commonService.formateAmount(singleData?.[0]?.ADR)
                                                        : commonService.formateAmount(0)}
                                                </td>
                                                <td className="border_right text-end">
                                                    {singleData?.[0]?.REV
                                                        ? commonService.formateAmount(singleData?.[0]?.REV)
                                                        : commonService.formateAmount(0)}
                                                </td>
                                                <td className="text-center">
                                                    {singleData?.[0]?.STLY_OCC
                                                        ? singleData?.[0]?.STLY_OCC
                                                        : 0}
                                                    %
                                                </td>
                                                <td className="text-center">
                                                    {singleData?.[0]?.STLY_RMS
                                                        ? commonService.formateRoom(
                                                            singleData?.[0]?.STLY_RMS
                                                        )
                                                        : 0}
                                                </td>
                                                <td className="text-end">
                                                    {singleData?.[0]?.STLY_ADR
                                                        ? commonService.formateAmount(
                                                            singleData?.[0]?.STLY_ADR
                                                        )
                                                        : commonService.formateAmount(0)}
                                                </td>
                                                <td className="border_right text-end">
                                                    {singleData?.[0]?.STLY_REV
                                                        ? commonService.formateAmount(
                                                            singleData?.[0]?.STLY_REV
                                                        )
                                                        : commonService.formateAmount(0)}
                                                </td>
                                                <td className="text-center">
                                                    {singleData?.[0]?.LY_OCC
                                                        ? singleData?.[0]?.LY_OCC
                                                        : 0}
                                                    %
                                                </td>
                                                <td className="text-center">
                                                    {singleData?.[0]?.LY_RMS
                                                        ? commonService.formateRoom(singleData?.[0]?.LY_RMS)
                                                        : 0}
                                                </td>
                                                <td className="text-end">
                                                    {singleData?.[0]?.LY_ADR
                                                        ? commonService.formateAmount(
                                                            singleData?.[0]?.LY_ADR
                                                        )
                                                        : commonService.formateAmount(0)}
                                                </td>
                                                <td className="border_right text-end">
                                                    {singleData?.[0]?.LY_REV
                                                        ? commonService.formateAmount(
                                                            singleData?.[0]?.LY_REV
                                                        )
                                                        : commonService.formateAmount(0)}
                                                </td>
                                                <td className="text-center">
                                                    {singleData?.[0]?.BUDGET_OCC
                                                        ? singleData?.[0]?.BUDGET_OCC
                                                        : 0}
                                                    %
                                                </td>
                                                <td className="text-center">
                                                    {singleData?.[0]?.BUDGET_RMS
                                                        ? commonService.formateRoom(
                                                            singleData?.[0]?.BUDGET_RMS
                                                        )
                                                        : 0}
                                                </td>
                                                <td className="text-end">
                                                    {singleData?.[0]?.BUDGET_ADR
                                                        ? commonService.formateAmount(
                                                            singleData?.[0]?.BUDGET_ADR
                                                        )
                                                        : commonService.formateAmount(0)}
                                                </td>
                                                <td className="border_right text-end">
                                                    {singleData?.[0]?.BUDGET_REV
                                                        ? commonService.formateAmount(
                                                            singleData?.[0]?.BUDGET_REV
                                                        )
                                                        : commonService.formateAmount(0)}
                                                </td>
                                                <td className="text-center">
                                                    {singleData?.[0]?.FORECAST_OCC
                                                        ? singleData?.[0]?.FORECAST_OCC
                                                        : 0}
                                                    %
                                                </td>
                                                <td className="text-center">
                                                    {singleData?.[0]?.FORECAST_RMS
                                                        ? commonService.formateRoom(
                                                            singleData?.[0]?.FORECAST_RMS
                                                        )
                                                        : 0}
                                                </td>
                                                <td className="text-end">
                                                    {singleData?.[0]?.FORECAST_ADR
                                                        ? commonService.formateAmount(
                                                            singleData?.[0]?.FORECAST_ADR
                                                        )
                                                        : commonService.formateAmount(0)}
                                                </td>
                                                <td className="text-end">
                                                    {singleData?.[0]?.FORECAST_REV
                                                        ? commonService.formateAmount(
                                                            singleData?.[0]?.FORECAST_REV
                                                        )
                                                        : commonService.formateAmount(0)}
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>

            {/* BOOKING PACE CHART */}
            <div className="mt-3 ebookingPace-widget-container">
                <p>{`Booking Pace (${moment(
                    bookingPaceChartDateRef.current
                        ? bookingPaceChartDateRef.current
                        : para?.asOfDate
                ).format("MMMM YYYY")})`}</p>
                {api !== 0 && (
                    <div className="gap-1 ebookingPace-widget-container-menu">
                       
                        <Button className="heading-menu-btns" type="button">
                            <img id={commonService.generateGlobalClickTrackerID("MonthlyData", "info", propertyCode)}
                                src={infoIcon}
                                alt="info"
                                onClick={() => {
                                    widgetDetailRef.current = {
                                        widgetdetails: "",
                                        usernote: "",
                                        compName: compName?.monthlyDataForEmail,
                                        widgetId: para?.widgetId,
                                    };
                                    setWidgetModal(true);
                                }}
                            />
                        </Button>
                    </div>
                )}
                {chartData && (
                    <div className="ForecastHorizontalChartInner">
                        <Line data={chartDetail} options={chartOptions} />
                    </div>
                )}
            </div>

            {/* SIXTY DAY OUTLOOK */}
            <div>
                <p>{`Next Month Outlook ${moment(
                    monthStartDateRef.current ? monthStartDateRef.current : new Date()
                ).format("MMMM YYYY")}`}</p>
                <SixtyDayChild
                    api={api}
                    para={{
                        ...para,
                        monthStart: monthStartDateRef.current,
                        monthEnd: monthEndDateRef.current,
                    }}
                />
            </div>

            {/* DRILLDOWN DATA */}
            <div className="mt-3 weeklydrilldown-widget-container">
                <p>{`Segment Drildown (${moment(
                    monthStartDateRef.current ? monthStartDateRef.current : para?.asOfDate
                ).format("MMMM YYYY")})`}</p>
                {api !== 0 && (
                    <div className="gap-1 weeklydrilldown-widget-container-menu">
                        <Button
                            className="heading-menu-btns"
                            type="button"
                            title="Send Mail"
                        >
                            <img id={commonService.generateGlobalClickTrackerID("MonthlyData", "emailicon", propertyCode)}
                                src={emailIcon}
                                alt="emailIcon"
                                onClick={() => {
                                    commonService.fnSendWidgetMail(
                                        tblids.drilldown,
                                        "Email Monthly Data",
                                        snapshotId,
                                        defaultAsOfDateFromRTK,
                                        "",
                                        para?.widgetId
                                    );
                                }}
                            />
                        </Button>
                        <Button className="heading-menu-btns" type="button">
                            <img id={commonService.generateGlobalClickTrackerID("MonthlyData", "info", propertyCode)}
                                src={infoIcon}
                                alt="info"
                                onClick={() => {
                                    widgetDetailRef.current = {
                                        widgetdetails: "",
                                        usernote: "",
                                        compName: compName?.weeklyDataForEmail,
                                        widgetId: para?.widgetId,
                                    };
                                    setWidgetModal(true);
                                }}
                            />
                        </Button>
                        <Button className="heading-menu-btns" type="button">
                            <img id={commonService.generateGlobalClickTrackerID("MonthlyData", "download", propertyCode)}
                                src={downloadIcon}
                                alt="download"
                                import={tblids.drilldown}
                                onClick={() =>
                                    commonService.fnExportInCSV(
                                        tblids.drilldown,
                                        // "Email Monthly Data"
                                        `${para?.propertyCode}-Email Monthly Data-${moment(
                                            new Date()
                                        ).format("MMDDYYYY")}`
                                    )
                                }
                            />
                        </Button>
                    </div>
                )}
                <div className="ViewPropertySetupTable">
                    <div className="table__container">
                        <div className="stripped__table">
                            <Table id={tblids.drilldown} responsive>
                                <thead className="tbl-header-sticky">
                                    <tr>
                                        <th className="border_right text-center"></th>
                                        <th colSpan={4} className="border_right text-center">
                                            Current Year
                                        </th>
                                        <th colSpan={4} className="border_right text-center">
                                            <div className="d-flex justify-content-center align-items-center gap-2">
                                                <label className="form-check-label">Last Year</label>
                                                <div className="form-check form-switch no-border-break from-groups jay-put-this-checkbox">
                                                    <input id={commonService.generateGlobalClickTrackerID("MonthlyData", "last-year-stly-room-nights", propertyCode)}
                                                        className="form-check-input me-2"
                                                        type="checkbox"
                                                        role="switch"
                                                        checked={stlyToggle}
                                                        onChange={() => {
                                                            setStylToggle(!stlyToggle);
                                                        }}
                                                    />
                                                    <label className="form-check-label">STLY</label>
                                                </div>
                                            </div>
                                        </th>
                                        <th colSpan={4} className="text-center">
                                            Variance
                                        </th>
                                    </tr>
                                    <tr>
                                        <th className="border_right"></th>
                                        <th className="text-center">Room Nights</th>
                                        <th className="text-end">ADR</th>
                                        <th className="text-end">Revenue</th>
                                        <th className="border_right text-center">
                                            Rev Contribution
                                        </th>
                                        <th className="text-center">Room Nights</th>
                                        <th className="text-end">ADR</th>
                                        <th className="text-end">Revenue</th>
                                        <th className="border_right text-center">
                                            Rev Contribution
                                        </th>
                                        <th className="text-center">Room Nights</th>
                                        <th className="text-end">ADR</th>
                                        <th className="text-end">Revenue</th>
                                        <th className="text-center">Rev Contribution</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr style={{ height: "80px", position: "relative" }}>
                                            <Loader />
                                        </tr>
                                    ) : (
                                        segmentDrilldownData &&
                                        segmentDrilldownData?.map((item, index) => {
                                            let msLeftRevContri = 0,
                                                msRightRevContri = 0;
                                            if (item?.left_REV > 0 && totalRef.current?.leftRev > 0) {
                                                msLeftRevContri = (
                                                    (parseInt(item?.left_REV) * 100) /
                                                    totalRef.current?.leftRev
                                                )?.toFixed(1);
                                            }

                                            if (
                                                item?.right_REV > 0 &&
                                                totalRef.current?.rightRev > 0
                                            ) {
                                                msRightRevContri = (
                                                    (parseInt(item?.right_REV) * 100) /
                                                    totalRef.current?.rightRev
                                                )?.toFixed(1);
                                            }
                                            let toggleRms = item?.right_RMS ? item?.right_RMS : 0;
                                            let toggleAdr = item?.right_ADR ? item?.right_ADR : 0;
                                            let toggleRev = item?.right_REV ? item?.right_REV : 0;
                                            let toggleVarRms = item?.varientRms;
                                            let toggleVarAdr = item?.varientAdr;
                                            let toggleVarRev = item?.varientRev;
                                            if (stlyToggle) {
                                                toggleRms = item?.stly_RMS ? item?.stly_RMS : 0;
                                                toggleAdr = item?.stly_ADR ? item?.stly_ADR : 0;
                                                toggleRev = item?.stly_REV ? item?.stly_REV : 0;
                                                toggleVarRms = item?.stlyRms;
                                                toggleVarAdr = item?.stlyAdr;
                                                toggleVarRev = item?.stlyRev;
                                                if (
                                                    item?.stly_REV > 0 &&
                                                    totalRef.current?.stly_rightRev > 0
                                                ) {
                                                    msRightRevContri = (
                                                        (parseInt(item?.stly_REV) * 100) /
                                                        totalRef.current?.stly_rightRev
                                                    )?.toFixed(1);
                                                } else {
                                                    msRightRevContri = 0;
                                                }
                                            }
                                            return (
                                                <>
                                                    <tr id={item?.guid} className="shadowOnHover">
                                                        <td className="border_right">
                                                            <div id={commonService.generateGlobalClickTrackerID("MonthlyData", "div-onclick", item)}
                                                                className={`d-flex gap-2`}
                                                                onClick={() => {
                                                                    let findSelectedMarketSegment =
                                                                        calledMarketSegmentRef.current?.filter(
                                                                            (x) => x === item?.name
                                                                        );

                                                                    if (findSelectedMarketSegment?.length > 0) {
                                                                        const classList =
                                                                            document.getElementsByClassName(
                                                                                item?.guid
                                                                            );
                                                                        if (
                                                                            classList?.[0]?.classList?.contains(
                                                                                "nestedTableRowNone"
                                                                            )
                                                                        ) {
                                                                            handleShowHideRow(item?.guid);
                                                                        } else {
                                                                            handleShowHideRow(item?.guid, item);
                                                                        }
                                                                    } else {
                                                                        if (!msLoading) {
                                                                            selectedMarketSegmentRef.current =
                                                                                item?.name;
                                                                            clickedTrRef.current = [item?.guid];

                                                                            getRateCodeData();
                                                                        }
                                                                    }
                                                                }}
                                                            >
                                                                <p>{item?.name}</p>
                                                                <img src={downArrow} alt="arrow" />

                                                                {msLoading &&
                                                                    selectedMarketSegmentRef.current ===
                                                                    item?.name && (
                                                                        <div
                                                                            class="spinner-border text-primary ms-2"
                                                                            role="status"
                                                                            style={{
                                                                                height: "13px",
                                                                                width: "13px",
                                                                                color: "#3565FC",
                                                                            }}
                                                                        >
                                                                            <span class="sr-only"></span>
                                                                        </div>
                                                                    )}
                                                            </div>
                                                        </td>
                                                        <td className="text-center">
                                                            {item?.left_RMS
                                                                ? commonService.formateRoom(item?.left_RMS)
                                                                : 0}
                                                        </td>
                                                        <td className="text-end">
                                                            {item?.left_ADR
                                                                ? `${commonService.formateAmount(
                                                                    item?.left_ADR
                                                                )}`
                                                                : `${commonService.formateAmount(0)}`}
                                                        </td>
                                                        <td className="text-end">
                                                            {item?.left_REV
                                                                ? `${commonService.formateAmount(
                                                                    item?.left_REV
                                                                )}`
                                                                : `${commonService.formateAmount(0)}`}
                                                        </td>
                                                        <td className="border_right text-center">
                                                            {msLeftRevContri}%
                                                        </td>
                                                        <td className="text-center">
                                                            {toggleRms
                                                                ? commonService.formateRoom(toggleRms)
                                                                : 0}
                                                        </td>
                                                        <td className="text-end">
                                                            {toggleAdr
                                                                ? `${commonService.formateAmount(toggleAdr)}`
                                                                : `${commonService.formateAmount(0)}`}
                                                        </td>
                                                        <td className="text-end">
                                                            {toggleRev
                                                                ? `${commonService.formateAmount(toggleRev)}`
                                                                : `${commonService.formateAmount(0)}`}
                                                        </td>
                                                        <td className="border_right text-center">
                                                            {msRightRevContri}%
                                                        </td>
                                                        <td
                                                            className={`text-center ${toggleVarRms < 0 ? "redText" : ""
                                                                }`}
                                                        >
                                                            {commonService.formateRoom(toggleVarRms)}
                                                        </td>
                                                        <td
                                                            className={`text-end ${toggleVarAdr < 0 ? "redText" : ""
                                                                }`}
                                                        >
                                                            {commonService.formateAmount(toggleVarAdr)}
                                                        </td>
                                                        <td
                                                            className={`text-end ${toggleVarRev < 0 ? "redText" : ""
                                                                }`}
                                                        >
                                                            {commonService.formateAmount(toggleVarRev)}
                                                        </td>
                                                        <td
                                                            className={`text-center ${(msLeftRevContri - msRightRevContri)?.toFixed(
                                                                1
                                                            ) < 0
                                                                ? "redText"
                                                                : ""
                                                                }`}
                                                        >
                                                            {(msLeftRevContri - msRightRevContri)?.toFixed(1)}
                                                            %
                                                        </td>
                                                    </tr>
                                                    {Array.isArray(item?.items) &&
                                                        item?.items?.length > 0 &&
                                                        item?.items?.map((rateCodeItem, rateCodeIndex) => {
                                                            let rateCodeLeftRevContri = 0,
                                                                rateCodeRightRevContri = 0;
                                                            if (
                                                                rateCodeItem?.left_REV > 0 &&
                                                                totalRef.current?.leftRev > 0
                                                            ) {
                                                                rateCodeLeftRevContri = (
                                                                    (parseInt(rateCodeItem?.left_REV) * 100) /
                                                                    totalRef.current?.leftRev
                                                                )?.toFixed(1);
                                                            }

                                                            if (
                                                                rateCodeItem?.right_REV > 0 &&
                                                                totalRef.current?.rightRev > 0
                                                            ) {
                                                                rateCodeRightRevContri = (
                                                                    (parseInt(rateCodeItem?.right_REV) * 100) /
                                                                    totalRef.current?.rightRev
                                                                )?.toFixed(1);
                                                            }
                                                            let rateCodeToggleRms = rateCodeItem?.right_RMS
                                                                ? rateCodeItem?.right_RMS
                                                                : 0;
                                                            let rateCodeToggleAdr = rateCodeItem?.right_ADR
                                                                ? rateCodeItem?.right_ADR
                                                                : 0;
                                                            let rateCodeToggleRev = rateCodeItem?.right_REV
                                                                ? rateCodeItem?.right_REV
                                                                : 0;
                                                            let rateCodeToggleVarRms =
                                                                rateCodeItem?.varientRms;
                                                            let rateCodeToggleVarAdr =
                                                                rateCodeItem?.varientAdr;
                                                            let rateCodeToggleVarRev =
                                                                rateCodeItem?.varientRev;
                                                            if (stlyToggle) {
                                                                rateCodeToggleRms = rateCodeItem?.stly_RMS
                                                                    ? rateCodeItem?.stly_RMS
                                                                    : 0;
                                                                rateCodeToggleAdr = rateCodeItem?.stly_ADR
                                                                    ? rateCodeItem?.stly_ADR
                                                                    : 0;
                                                                rateCodeToggleRev = rateCodeItem?.stly_REV
                                                                    ? rateCodeItem?.stly_REV
                                                                    : 0;
                                                                rateCodeToggleVarRms = rateCodeItem?.stlyRms;
                                                                rateCodeToggleVarAdr = rateCodeItem?.stlyAdr;
                                                                rateCodeToggleVarRev = rateCodeItem?.stlyRev;
                                                                if (
                                                                    rateCodeItem?.stly_REV > 0 &&
                                                                    totalRef.current?.stlyRev > 0
                                                                ) {
                                                                    rateCodeRightRevContri = (
                                                                        (parseInt(rateCodeItem?.stly_REV) * 100) /
                                                                        totalRef.current?.stlyRev
                                                                    )?.toFixed(1);
                                                                } else {
                                                                    rateCodeRightRevContri = 0;
                                                                }
                                                            }
                                                            return (
                                                                <>
                                                                    <tr
                                                                        className={`${item?.guid} nestedTableRowNone shadowOnHover`}
                                                                        id={rateCodeItem?.guid}
                                                                    >
                                                                        <td className="border_right">
                                                                            <div id={commonService.generateGlobalClickTrackerID("MonthlyData", "div-onclick", item)}
                                                                                style={{ paddingLeft: "10px" }}
                                                                                className="d-flex gap-2"
                                                                                onClick={() => {
                                                                                    if (!rateCodeLoading) {
                                                                                        selectedMarketSegmentRef.current =
                                                                                            item?.name;
                                                                                        selectedRateCodeRef.current =
                                                                                            rateCodeItem?.name;
                                                                                    }
                                                                                    let findSelectedRateCode =
                                                                                        calledRateCodeRef.current?.filter(
                                                                                            (x) =>
                                                                                                x?.ms ===
                                                                                                selectedMarketSegmentRef.current &&
                                                                                                x?.rc ===
                                                                                                selectedRateCodeRef.current
                                                                                        );

                                                                                    if (
                                                                                        findSelectedRateCode?.length > 0
                                                                                    ) {
                                                                                        const classList =
                                                                                            document.getElementsByClassName(
                                                                                                rateCodeItem?.guid
                                                                                            );

                                                                                        if (
                                                                                            classList?.[0]?.classList?.contains(
                                                                                                "nestedTableRowNone"
                                                                                            )
                                                                                        ) {
                                                                                            handleShowHideRow(
                                                                                                rateCodeItem?.guid
                                                                                            );
                                                                                        } else {
                                                                                            handleShowHideRow(
                                                                                                rateCodeItem?.guid,
                                                                                                rateCodeItem
                                                                                            );
                                                                                        }
                                                                                    } else {
                                                                                        if (!rateCodeLoading) {
                                                                                            clickedTrRef.current = [
                                                                                                ...clickedTrRef.current,
                                                                                                rateCodeItem?.guid,
                                                                                            ];

                                                                                            getCompanyData();
                                                                                        }
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <p>
                                                                                    {rateCodeItem?.name +
                                                                                        (rateCodeItem?.RateCodeDescript
                                                                                            ? " - " +
                                                                                            rateCodeItem?.RateCodeDescript
                                                                                            : "")}
                                                                                </p>
                                                                                <img src={downArrow} />
                                                                                {rateCodeLoading &&
                                                                                    selectedMarketSegmentRef.current ===
                                                                                    item?.name &&
                                                                                    selectedRateCodeRef.current ===
                                                                                    rateCodeItem?.name && (
                                                                                        <div
                                                                                            class="spinner-border text-primary ms-2"
                                                                                            role="status"
                                                                                            style={{
                                                                                                height: "13px",
                                                                                                width: "13px",
                                                                                                color: "#3565FC",
                                                                                            }}
                                                                                        >
                                                                                            <span class="sr-only"></span>
                                                                                        </div>
                                                                                    )}
                                                                            </div>
                                                                        </td>

                                                                        <td className="text-center">
                                                                            {rateCodeItem?.left_RMS
                                                                                ? commonService.formateRoom(
                                                                                    rateCodeItem?.left_RMS
                                                                                )
                                                                                : 0}
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {rateCodeItem?.left_ADR
                                                                                ? `${commonService.formateAmount(
                                                                                    rateCodeItem?.left_ADR
                                                                                )}`
                                                                                : `${commonService.formateAmount(0)}`}
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {rateCodeItem?.left_REV
                                                                                ? `${commonService.formateAmount(
                                                                                    rateCodeItem?.left_REV
                                                                                )}`
                                                                                : `${commonService.formateAmount(0)}`}
                                                                        </td>
                                                                        <td className="border_right text-center">
                                                                            {rateCodeLeftRevContri}%
                                                                        </td>
                                                                        <td className="text-center">
                                                                            {rateCodeToggleRms
                                                                                ? commonService.formateRoom(
                                                                                    rateCodeToggleRms
                                                                                )
                                                                                : 0}
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {rateCodeToggleAdr
                                                                                ? `${commonService.formateAmount(
                                                                                    rateCodeToggleAdr
                                                                                )}`
                                                                                : `${commonService.formateAmount(0)}`}
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {rateCodeToggleRev
                                                                                ? `${commonService.formateAmount(
                                                                                    rateCodeToggleRev
                                                                                )}`
                                                                                : `${commonService.formateAmount(0)}`}
                                                                        </td>
                                                                        <td className="border_right text-center">
                                                                            {rateCodeRightRevContri}%
                                                                        </td>
                                                                        <td
                                                                            className={`text-center ${rateCodeToggleVarRms < 0
                                                                                ? "redText"
                                                                                : ""
                                                                                }`}
                                                                        >
                                                                            {commonService.formateRoom(
                                                                                rateCodeToggleVarRms
                                                                            )}
                                                                        </td>
                                                                        <td
                                                                            className={`text-end ${rateCodeToggleVarAdr < 0
                                                                                ? "redText"
                                                                                : ""
                                                                                }`}
                                                                        >
                                                                            {commonService.formateAmount(
                                                                                rateCodeToggleVarAdr
                                                                            )}
                                                                        </td>
                                                                        <td
                                                                            className={`text-end ${rateCodeToggleVarRev < 0
                                                                                ? "redText"
                                                                                : ""
                                                                                }`}
                                                                        >
                                                                            {commonService.formateAmount(
                                                                                rateCodeToggleVarRev
                                                                            )}
                                                                        </td>
                                                                        <td
                                                                            className={`text-center ${(
                                                                                rateCodeLeftRevContri -
                                                                                rateCodeRightRevContri
                                                                            )?.toFixed(1) < 0
                                                                                ? "redText"
                                                                                : ""
                                                                                }`}
                                                                        >
                                                                            {(
                                                                                rateCodeLeftRevContri -
                                                                                rateCodeRightRevContri
                                                                            )?.toFixed(1)}
                                                                            %
                                                                        </td>
                                                                    </tr>
                                                                    {Array.isArray(rateCodeItem?.items) &&
                                                                        rateCodeItem?.items?.length > 0 &&
                                                                        rateCodeItem?.items?.map(
                                                                            (companyItem, companyIndex) => {
                                                                                let companyItemLeftRevContri = 0,
                                                                                    companyItemRightRevContri = 0;
                                                                                if (
                                                                                    companyItem?.left_REV > 0 &&
                                                                                    totalRef.current?.leftRev > 0
                                                                                ) {
                                                                                    companyItemLeftRevContri = (
                                                                                        (parseInt(companyItem?.left_REV) *
                                                                                            100) /
                                                                                        totalRef.current?.leftRev
                                                                                    )?.toFixed(1);
                                                                                }

                                                                                if (
                                                                                    companyItem?.right_REV > 0 &&
                                                                                    totalRef.current?.rightRev > 0
                                                                                ) {
                                                                                    companyItemRightRevContri = (
                                                                                        (parseInt(companyItem?.right_REV) *
                                                                                            100) /
                                                                                        totalRef.current?.rightRev
                                                                                    )?.toFixed(1);
                                                                                }
                                                                                let companyToggleRms =
                                                                                    companyItem?.right_RMS
                                                                                        ? companyItem?.right_RMS
                                                                                        : 0;
                                                                                let companyToggleAdr =
                                                                                    companyItem?.right_ADR
                                                                                        ? companyItem?.right_ADR
                                                                                        : 0;
                                                                                let companyToggleRev =
                                                                                    companyItem?.right_REV
                                                                                        ? companyItem?.right_REV
                                                                                        : 0;
                                                                                let companyToggleVarRms =
                                                                                    companyItem?.varientRms;
                                                                                let companyToggleVarAdr =
                                                                                    companyItem?.varientAdr;
                                                                                let companyToggleVarRev =
                                                                                    companyItem?.varientRev;
                                                                                if (stlyToggle) {
                                                                                    companyToggleRms =
                                                                                        companyItem?.stly_RMS
                                                                                            ? companyItem?.stly_RMS
                                                                                            : 0;
                                                                                    companyToggleAdr =
                                                                                        companyItem?.stly_ADR
                                                                                            ? companyItem?.stly_ADR
                                                                                            : 0;
                                                                                    companyToggleRev =
                                                                                        companyItem?.stly_REV
                                                                                            ? companyItem?.stly_REV
                                                                                            : 0;
                                                                                    companyToggleVarRms =
                                                                                        companyItem?.stlyRms;
                                                                                    companyToggleVarAdr =
                                                                                        companyItem?.stlyAdr;
                                                                                    companyToggleVarRev =
                                                                                        companyItem?.stlyRev;
                                                                                    if (
                                                                                        companyItem?.stly_REV > 0 &&
                                                                                        totalRef.current?.stlyRev > 0
                                                                                    ) {
                                                                                        companyItemRightRevContri = (
                                                                                            (parseInt(companyItem?.stly_REV) *
                                                                                                100) /
                                                                                            totalRef.current?.stlyRev
                                                                                        )?.toFixed(1);
                                                                                    } else {
                                                                                        companyItemRightRevContri = 0;
                                                                                    }
                                                                                }
                                                                                return (
                                                                                    <>
                                                                                        <tr
                                                                                            className={`${rateCodeItem?.guid} nestedTableRowNone shadowOnHover`}
                                                                                            id={companyItem?.guid}
                                                                                        >
                                                                                            <td className="border_right">
                                                                                                <div id={commonService.generateGlobalClickTrackerID("MonthlyData", "div-onclick", item)}
                                                                                                    style={{
                                                                                                        paddingLeft: "20px",
                                                                                                    }}
                                                                                                    className="d-flex gap-2"
                                                                                                    onClick={() => {
                                                                                                        if (!companyLoading) {
                                                                                                            selectedMarketSegmentRef.current =
                                                                                                                item?.name;
                                                                                                            selectedRateCodeRef.current =
                                                                                                                rateCodeItem?.name;
                                                                                                            selectedCompanyRef.current =
                                                                                                                companyItem?.name;
                                                                                                        }
                                                                                                        let findSelectedCompany =
                                                                                                            calledCompanyRef.current?.filter(
                                                                                                                (x) =>
                                                                                                                    x?.ms ===
                                                                                                                    selectedMarketSegmentRef.current &&
                                                                                                                    x?.rc ===
                                                                                                                    selectedRateCodeRef.current &&
                                                                                                                    x?.company ===
                                                                                                                    selectedCompanyRef.current
                                                                                                            );

                                                                                                        if (
                                                                                                            findSelectedCompany?.length >
                                                                                                            0
                                                                                                        ) {
                                                                                                            const classList =
                                                                                                                document.getElementsByClassName(
                                                                                                                    companyItem?.guid
                                                                                                                );

                                                                                                            if (
                                                                                                                classList?.[0]?.classList?.contains(
                                                                                                                    "nestedTableRowNone"
                                                                                                                )
                                                                                                            ) {
                                                                                                                handleShowHideRow(
                                                                                                                    companyItem?.guid
                                                                                                                );
                                                                                                            } else {
                                                                                                                handleShowHideRow(
                                                                                                                    companyItem?.guid,
                                                                                                                    companyItem
                                                                                                                );
                                                                                                            }
                                                                                                        } else {
                                                                                                            if (!companyLoading) {
                                                                                                                clickedTrRef.current = [
                                                                                                                    ...clickedTrRef.current,
                                                                                                                    companyItem?.guid,
                                                                                                                ];

                                                                                                                getGuestData();
                                                                                                            }
                                                                                                        }
                                                                                                    }}
                                                                                                >
                                                                                                    <p>{companyItem?.name}</p>
                                                                                                    <img src={downArrow} />
                                                                                                    {companyLoading &&
                                                                                                        selectedMarketSegmentRef.current ===
                                                                                                        item?.name &&
                                                                                                        selectedRateCodeRef.current ===
                                                                                                        rateCodeItem?.name &&
                                                                                                        selectedCompanyRef.current ===
                                                                                                        companyItem?.name && (
                                                                                                            <div
                                                                                                                class="spinner-border text-primary ms-2"
                                                                                                                role="status"
                                                                                                                style={{
                                                                                                                    height: "13px",
                                                                                                                    width: "13px",
                                                                                                                    color: "#3565FC",
                                                                                                                }}
                                                                                                            >
                                                                                                                <span class="sr-only"></span>
                                                                                                            </div>
                                                                                                        )}
                                                                                                </div>
                                                                                            </td>

                                                                                            <td className="text-center">
                                                                                                {companyItem?.left_RMS
                                                                                                    ? commonService.formateRoom(
                                                                                                        companyItem?.left_RMS
                                                                                                    )
                                                                                                    : 0}
                                                                                            </td>
                                                                                            <td className="text-end">
                                                                                                {companyItem?.left_ADR
                                                                                                    ? `${commonService.formateAmount(
                                                                                                        companyItem?.left_ADR
                                                                                                    )}`
                                                                                                    : `${commonService.formateAmount(
                                                                                                        0
                                                                                                    )}`}
                                                                                            </td>
                                                                                            <td className="text-end">
                                                                                                {companyItem?.left_REV
                                                                                                    ? `${commonService.formateAmount(
                                                                                                        companyItem?.left_REV
                                                                                                    )}`
                                                                                                    : `${commonService.formateAmount(
                                                                                                        0
                                                                                                    )}`}
                                                                                            </td>
                                                                                            <td className="border_right text-center">
                                                                                                {companyItemLeftRevContri}%
                                                                                            </td>
                                                                                            <td className="text-center">
                                                                                                {companyToggleRms
                                                                                                    ? commonService.formateRoom(
                                                                                                        companyToggleRms
                                                                                                    )
                                                                                                    : 0}
                                                                                            </td>
                                                                                            <td className="text-end">
                                                                                                {companyToggleAdr
                                                                                                    ? `${commonService.formateAmount(
                                                                                                        companyToggleAdr
                                                                                                    )}`
                                                                                                    : `${commonService.formateAmount(
                                                                                                        0
                                                                                                    )}`}
                                                                                            </td>
                                                                                            <td className="text-end">
                                                                                                {companyToggleRev
                                                                                                    ? `${commonService.formateAmount(
                                                                                                        companyToggleRev
                                                                                                    )}`
                                                                                                    : `${commonService.formateAmount(
                                                                                                        0
                                                                                                    )}`}
                                                                                            </td>
                                                                                            <td className="border_right text-center">
                                                                                                {companyItemRightRevContri}%
                                                                                            </td>
                                                                                            <td
                                                                                                className={`text-center ${companyToggleVarRms < 0
                                                                                                    ? "redText"
                                                                                                    : ""
                                                                                                    }`}
                                                                                            >
                                                                                                {commonService.formateRoom(
                                                                                                    companyToggleVarRms
                                                                                                )}
                                                                                            </td>
                                                                                            <td
                                                                                                className={`text-end ${companyToggleVarAdr < 0
                                                                                                    ? "redText"
                                                                                                    : ""
                                                                                                    }`}
                                                                                            >
                                                                                                {commonService.formateAmount(
                                                                                                    companyToggleVarAdr
                                                                                                )}
                                                                                            </td>
                                                                                            <td
                                                                                                className={`text-end ${companyToggleVarRev < 0
                                                                                                    ? "redText"
                                                                                                    : ""
                                                                                                    }`}
                                                                                            >
                                                                                                {commonService.formateAmount(
                                                                                                    companyToggleVarRev
                                                                                                )}
                                                                                            </td>
                                                                                            <td
                                                                                                className={`text-center ${(
                                                                                                    companyItemLeftRevContri -
                                                                                                    companyItemRightRevContri
                                                                                                )?.toFixed(1) < 0
                                                                                                    ? "redText"
                                                                                                    : ""
                                                                                                    }`}
                                                                                            >
                                                                                                {(
                                                                                                    companyItemLeftRevContri -
                                                                                                    companyItemRightRevContri
                                                                                                )?.toFixed(1)}
                                                                                                %
                                                                                            </td>
                                                                                        </tr>
                                                                                        {Array.isArray(
                                                                                            companyItem?.items
                                                                                        ) &&
                                                                                            companyItem?.items?.length > 0 &&
                                                                                            companyItem?.items?.map(
                                                                                                (guestItem, guestIndex) => {
                                                                                                    let guestLeftRevContri = 0,
                                                                                                        guestRightRevContri = 0;
                                                                                                    if (
                                                                                                        guestItem?.left_REV > 0 &&
                                                                                                        totalRef.current?.leftRev >
                                                                                                        0
                                                                                                    ) {
                                                                                                        guestLeftRevContri = (
                                                                                                            (parseInt(
                                                                                                                guestItem?.left_REV
                                                                                                            ) *
                                                                                                                100) /
                                                                                                            totalRef.current?.leftRev
                                                                                                        )?.toFixed(1);
                                                                                                    }

                                                                                                    if (
                                                                                                        guestItem?.right_REV > 0 &&
                                                                                                        totalRef.current?.rightRev >
                                                                                                        0
                                                                                                    ) {
                                                                                                        guestRightRevContri = (
                                                                                                            (parseInt(
                                                                                                                guestItem?.right_REV
                                                                                                            ) *
                                                                                                                100) /
                                                                                                            totalRef.current?.rightRev
                                                                                                        )?.toFixed(1);
                                                                                                    }
                                                                                                    let guestToggleRms =
                                                                                                        guestItem?.right_RMS
                                                                                                            ? guestItem?.right_RMS
                                                                                                            : 0;
                                                                                                    let guestToggleAdr =
                                                                                                        guestItem?.right_ADR
                                                                                                            ? guestItem?.right_ADR
                                                                                                            : 0;
                                                                                                    let guestToggleRev =
                                                                                                        guestItem?.right_REV
                                                                                                            ? guestItem?.right_REV
                                                                                                            : 0;
                                                                                                    let guestToggleVarRms =
                                                                                                        guestItem?.varientRms;
                                                                                                    let guestToggleVarAdr =
                                                                                                        guestItem?.varientAdr;
                                                                                                    let guestToggleVarRev =
                                                                                                        guestItem?.varientRev;
                                                                                                    if (stlyToggle) {
                                                                                                        guestToggleRms =
                                                                                                            guestItem?.stly_RMS
                                                                                                                ? guestItem?.stly_RMS
                                                                                                                : 0;
                                                                                                        guestToggleAdr =
                                                                                                            guestItem?.stly_ADR
                                                                                                                ? guestItem?.stly_ADR
                                                                                                                : 0;
                                                                                                        guestToggleRev =
                                                                                                            guestItem?.stly_REV
                                                                                                                ? guestItem?.stly_REV
                                                                                                                : 0;
                                                                                                        guestToggleVarRms =
                                                                                                            guestItem?.stlyRms;
                                                                                                        guestToggleVarAdr =
                                                                                                            guestItem?.stlyAdr;
                                                                                                        guestToggleVarRev =
                                                                                                            guestItem?.stlyRev;
                                                                                                        if (
                                                                                                            guestItem?.stly_REV > 0 &&
                                                                                                            totalRef.current
                                                                                                                ?.stlyRev > 0
                                                                                                        ) {
                                                                                                            guestRightRevContri = (
                                                                                                                (parseInt(
                                                                                                                    guestItem?.stly_REV
                                                                                                                ) *
                                                                                                                    100) /
                                                                                                                totalRef.current
                                                                                                                    ?.stlyRev
                                                                                                            )?.toFixed(1);
                                                                                                        } else {
                                                                                                            guestRightRevContri = 0;
                                                                                                        }
                                                                                                    }
                                                                                                    return (
                                                                                                        <tr id={commonService.generateGlobalClickTrackerID("MonthlyData", "tr-elem", item)}
                                                                                                            className={`${companyItem?.guid} nestedTableRowNone shadowOnHover`}
                                                                                                            onClick={(e) => {
                                                                                                                checkActiveRow(e);
                                                                                                            }}
                                                                                                        >
                                                                                                            <td className="border_right">
                                                                                                                <div
                                                                                                                    style={{
                                                                                                                        paddingLeft: "30px",
                                                                                                                    }}
                                                                                                                    className="d-flex gap-2"
                                                                                                                >
                                                                                                                    <p>
                                                                                                                        {guestItem?.name}
                                                                                                                    </p>
                                                                                                                </div>
                                                                                                            </td>
                                                                                                            <td className="text-center">
                                                                                                                {guestItem?.left_RMS
                                                                                                                    ? commonService.formateRoom(
                                                                                                                        guestItem?.left_RMS
                                                                                                                    )
                                                                                                                    : 0}
                                                                                                            </td>
                                                                                                            <td className="text-end">
                                                                                                                {guestItem?.left_ADR
                                                                                                                    ? `${commonService.formateAmount(
                                                                                                                        guestItem?.left_ADR
                                                                                                                    )}`
                                                                                                                    : `${commonService.formateAmount(
                                                                                                                        0
                                                                                                                    )}`}
                                                                                                            </td>
                                                                                                            <td className="text-end">
                                                                                                                {guestItem?.left_REV
                                                                                                                    ? `${commonService.formateAmount(
                                                                                                                        guestItem?.left_REV
                                                                                                                    )}`
                                                                                                                    : `${commonService.formateAmount(
                                                                                                                        0
                                                                                                                    )}`}
                                                                                                            </td>
                                                                                                            <td className="border_right text-center">
                                                                                                                {guestLeftRevContri}%
                                                                                                            </td>
                                                                                                            <td className="text-center">
                                                                                                                {guestToggleRms
                                                                                                                    ? commonService.formateRoom(
                                                                                                                        guestToggleRms
                                                                                                                    )
                                                                                                                    : 0}
                                                                                                            </td>
                                                                                                            <td className="text-end">
                                                                                                                {guestToggleAdr
                                                                                                                    ? `${commonService.formateAmount(
                                                                                                                        guestToggleAdr
                                                                                                                    )}`
                                                                                                                    : `${commonService.formateAmount(
                                                                                                                        0
                                                                                                                    )}`}
                                                                                                            </td>
                                                                                                            <td className="text-end">
                                                                                                                {guestToggleRev
                                                                                                                    ? `${commonService.formateAmount(
                                                                                                                        guestToggleRev
                                                                                                                    )}`
                                                                                                                    : `${commonService.formateAmount(
                                                                                                                        0
                                                                                                                    )}`}
                                                                                                            </td>
                                                                                                            <td className="border_right text-center">
                                                                                                                {guestRightRevContri}%
                                                                                                            </td>
                                                                                                            <td
                                                                                                                className={`text-center ${guestToggleVarRms < 0
                                                                                                                    ? "redText"
                                                                                                                    : ""
                                                                                                                    }`}
                                                                                                            >
                                                                                                                {commonService.formateRoom(
                                                                                                                    guestToggleVarRms
                                                                                                                )}
                                                                                                            </td>
                                                                                                            <td
                                                                                                                className={`text-end ${guestToggleVarAdr < 0
                                                                                                                    ? "redText"
                                                                                                                    : ""
                                                                                                                    }`}
                                                                                                            >
                                                                                                                {commonService.formateAmount(
                                                                                                                    guestToggleVarAdr
                                                                                                                )}
                                                                                                            </td>
                                                                                                            <td
                                                                                                                className={`text-end ${guestToggleVarRev < 0
                                                                                                                    ? "redText"
                                                                                                                    : ""
                                                                                                                    }`}
                                                                                                            >
                                                                                                                {commonService.formateAmount(
                                                                                                                    guestToggleVarRev
                                                                                                                )}
                                                                                                            </td>
                                                                                                            <td
                                                                                                                className={`text-center ${(
                                                                                                                    guestLeftRevContri -
                                                                                                                    guestRightRevContri
                                                                                                                )?.toFixed(1) < 0
                                                                                                                    ? "redText"
                                                                                                                    : ""
                                                                                                                    }`}
                                                                                                            >
                                                                                                                {(
                                                                                                                    guestLeftRevContri -
                                                                                                                    guestRightRevContri
                                                                                                                )?.toFixed(1)}
                                                                                                                %
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    );
                                                                                                }
                                                                                            )}
                                                                                    </>
                                                                                );
                                                                            }
                                                                        )}
                                                                </>
                                                            );
                                                        })}
                                                    {index === segmentDrilldownData?.length - 1 && (
                                                        <tr>
                                                            <td className="border_right boldTd">Totals</td>
                                                            <td className="text-center boldTd">
                                                                {commonService.formateRoom(totalRef.current.leftRoom)}
                                                            </td>
                                                            <td className="text-end boldTd">
                                                                {totalRef.current.leftRoom > 0 && totalRef.current.leftRev > 0
                                                                    ? commonService.formateAmount(
                                                                        Math.round(
                                                                            totalRef.current.leftRev /
                                                                            totalRef.current.leftRoom
                                                                        )
                                                                    )
                                                                    : commonService.formateAmount(0)}
                                                            </td>
                                                            <td className="text-end boldTd">
                                                                {commonService.formateAmount(
                                                                    totalRef.current.leftRev
                                                                )}
                                                            </td>
                                                            <td className="border_right text-center boldTd">
                                                                {totalRef.current.leftRevContri}%
                                                            </td>
                                                            <td className="text-center boldTd">
                                                                {commonService.formateRoom(
                                                                    stlyToggle
                                                                        ? totalRef.current.stly_rightRoom
                                                                        : totalRef.current.rightRoom
                                                                )}
                                                            </td>
                                                            <td className="text-end boldTd">
                                                                {stlyToggle
                                                                    ? totalRef.current.stly_rightRoom > 0 &&
                                                                        totalRef.current.stly_rightRev > 0
                                                                        ? commonService.formateAmount(
                                                                            Math.round(
                                                                                totalRef.current.stly_rightRev /
                                                                                totalRef.current.stly_rightRoom
                                                                            )
                                                                        )
                                                                        : commonService.formateAmount(0)
                                                                    : totalRef.current.rightRoom > 0 &&
                                                                        totalRef.current.rightRev > 0
                                                                        ? commonService.formateAmount(
                                                                            Math.round(
                                                                                totalRef.current.rightRev /
                                                                                totalRef.current.rightRoom
                                                                            )
                                                                        )
                                                                        : commonService.formateAmount(0)}
                                                            </td>
                                                            <td className="text-end boldTd">
                                                                {commonService.formateAmount(
                                                                    stlyToggle
                                                                        ? totalRef.current.stly_rightRev
                                                                        : totalRef.current.rightRev
                                                                )}
                                                            </td>
                                                            <td className="border_right text-center boldTd">
                                                                {stlyToggle
                                                                    ? totalRef.current.stly_rightRevContri
                                                                    : totalRef.current.rightRevContri}
                                                                %
                                                            </td>


                                                            <td className="text-center boldTd">
                                                                {stlyToggle
                                                                    ? commonService.formateRoom(
                                                                        totalRef.current.leftRoom -
                                                                        totalRef.current.stly_rightRoom
                                                                    )
                                                                    : commonService.formateRoom(
                                                                        totalRef.current.leftRoom -
                                                                        totalRef.current.rightRoom
                                                                    )}
                                                            </td>
                                                            <td className="text-end boldTd">
                                                                {propertyDetailFromRTK?.currency_term
                                                                    ? propertyDetailFromRTK?.currency_term
                                                                    : "$"}
                                                                {stlyToggle
                                                                    ? (totalRef.current.leftRoom > 0 &&
                                                                        totalRef.current.leftRev > 0
                                                                        ? Math.round(
                                                                            totalRef.current.leftRev /
                                                                            totalRef.current.leftRoom
                                                                        )
                                                                        : 0) -
                                                                    (totalRef.current.stly_rightRoom > 0 &&
                                                                        totalRef.current.stly_rightRev > 0
                                                                        ? Math.round(
                                                                            totalRef.current.stly_rightRev /
                                                                            totalRef.current.stly_rightRoom
                                                                        )
                                                                        : 0)
                                                                    : (totalRef.current.leftRoom > 0 &&
                                                                        totalRef.current.leftRev > 0
                                                                        ? Math.round(
                                                                            totalRef.current.leftRev /
                                                                            totalRef.current.leftRoom
                                                                        )
                                                                        : 0) -
                                                                    (totalRef.current.rightRoom > 0 &&
                                                                        totalRef.current.rightRev > 0
                                                                        ? Math.round(
                                                                            totalRef.current.rightRev /
                                                                            totalRef.current.rightRoom
                                                                        )
                                                                        : 0)}
                                                            </td>
                                                            <td className="text-end boldTd">
                                                                {stlyToggle
                                                                    ? commonService.formateAmount(
                                                                        totalRef.current.leftRev -
                                                                        totalRef.current.stly_rightRev
                                                                    )
                                                                    : commonService.formateAmount(
                                                                        totalRef.current.leftRev -
                                                                        totalRef.current.rightRev
                                                                    )}
                                                            </td>
                                                            <td className="boldTd"></td>
                                                        </tr>
                                                    )}
                                                </>
                                            );
                                        })
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </div>
            {api !== 0 && <Comments widgetDetails={para} editorId={"MonthlyData"} />}

            {/* MARKET SEGMENT CHART */}
            <div className="mt-3">
                <p>Market Mix</p>
                <div>
                    {loading ? (
                        <Loader />
                    ) : msChartData ? (
                        <DoughnutChart data={msChartData} options={chartDoughnutOptions} />
                    ) : (
                        <div className="d-flex justify-content-center">No Data Found</div>
                    )}
                </div>
            </div>

            {/* EVENT STRATEGY */}
            <div className="mt-3">
                <p>Event Strategy</p>
                <EventStretegy
                    api={api}
                    para={{
                        ...para,
                        monthStart: monthStartDateRef.current,
                        monthEnd: monthEndDateRef.current,
                    }}
                />
            </div>

            {showNoteSidebar && (
                <AddWidgetModal
                    showModal={showNoteSidebar}
                    closeModal={closeNoteSideBar}
                    widgetId={para?.widgetId}
                    propertyId={propertyDetailFromRTK?.propertyid}
                    rowTitle={para?.rowTitle}
                />
            )}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}
        </div>
    );
};

export default MonthlyData;
